import { ChangeDetectorRef, Component, Inject, OnInit,LOCALE_ID, ViewRef} from '@angular/core'
import {
	MatDialog,
	MatDialogRef,
	MAT_DIALOG_DATA
} from '@angular/material'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import {  ConsultationService, DialogService, StateService, VisiteService , ListeService} from '../../../../../services'

import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import moment from 'moment'
import { LoadDialogComponent } from '../../../layout/dialogs/load-dialog/load.component'
import { ChoiceCourrierComponent } from '../../../layout/dialogs/choice-courrier-dialog/choice-courrier.component'
import { CreateConsultationDialogComponent } from '../create-consultation-dialog/create-consultation-dialog.component'



const KEY = 'visite-list-dialog'



@Component({
	selector: 'atyl-visite-list-dialog',
	templateUrl: './visite-list-dialog.component.html',
	styleUrls: ['./visite-list-dialog.component.scss'],
	providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
    //{ provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    {
      provide: MAT_DATE_FORMATS, useValue: {
        parse: {
          dateInput: 'L',
        },
        display: {
          dateInput: 'L',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'L',
          monthYearA11yLabel: 'MMM YYYY',
        },
      }
    },
  ],
})
@Stringable({
	path: 'views/partials/content/actions/visite-list-dialog',
	key: KEY
})
export class VisiteListDialog extends BaseDialogComponent implements OnInit {
	
    consultation: any;
    display: string = "";
    loading: boolean = true;
    noVisits: boolean = false;
    @StringableValues(KEY) strings: any
    visiteToOpen: number = 0
    selectedOrder:any;
    selectedSortBy:any;
    countSelectedVisit:number=0;
    selectedVisits:any[]=[];
    consultInfos: any;
    subtitle: any;
    
	constructor(
		changeDetectorRef: ChangeDetectorRef,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<VisiteListDialog>,
		public dialog: MatDialog,
		dialogService: DialogService,
    private stateService: StateService,
    private visiteService: VisiteService,
    private consultationService: ConsultationService,
	private listeService: ListeService

	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}

	ngOnInit() {
       console.log("visite List dialog data",this.data)
        if(this.data){
            this.consultation = this.data.consultation;
            this.setConsultInfos();
            console.log('ngOnInit consultation:',this.consultation);
            if(this.consultation.visites == 0){
                this.noVisits = true;
            }
            this.loading = this.data.loading;
            console.log("ngOnInit loading:", this.loading);

            if(this.data.visiteToOpen != undefined && this.data.visiteToOpen != undefined){
              this.visiteToOpen = this.data.visiteToOpen;
            }
            this.changeDetectorRef.detectChanges();
        }
	}

    ngOnChanges() {
        this.loadHeader();
        this.changeDetectorRef.detectChanges()
    }

    loadHeader() {
        if (this.consultation!=undefined && this.consultation && this.consultation.visitesObj ) {
             let subHeader =  ""
             console.log("consultation header",this.consultation);
             if (this.consultation.type!=undefined && this.consultation.type) 
                 subHeader+=this.consultation.type.libelle;
                 
              if (this.consultation.domicile!=undefined && this.consultation.domicile)  
                 subHeader+= '&nbsp;<span class="subheader_bagde subheader_bagde_domicile">D</span>';
                 
              if (this.consultation.ponctuel!=undefined && this.consultation.ponctuel)  
                 subHeader+= '&nbsp;<span class="subheader_bagde subheader_bagde_ponctuel">P</span>';     
                 
             if (this.consultation.lieu!=undefined && this.consultation.lieu) 
                 subHeader+=" à "+ this.consultation.lieu.NOM;
                      
             let begin=false;
 
             if (this.consultation.date_debut!=undefined && this.consultation.date_debut) {
                 subHeader+="<br/> Du " + moment(this.consultation.date_debut).format('DD/MM/YYYY HH:mm');                   
                 begin=true; 
             }
            
             if (this.consultation.date_fin!=undefined && this.consultation.date_fin) {
                
                 subHeader+=(begin) ?" au ": "<br/> le ";
                  
                 subHeader+= moment(this.consultation.date_fin).format('DD/MM/YYYY HH:mm');                     
                 
             }
             if (this.consultation.professionels!=undefined 
             && this.consultation.professionels
              && this.consultation.professionels.length>0) {
                 var prfs=[];
                 for(let i=0;i<this.consultation.professionels.length;i++) {
                     let prf=this.consultation.professionels[i].NOM+" "+this.consultation.professionels[i].PRENOM
                     prfs.push(prf);
                 }
                  subHeader+="<br/>"+prfs.join(" , ");
                 
             }
             
             console.log("VisiteListDialog list subHeader",subHeader);
             this.stateService.updateSubHeader(subHeader)
         }
     
   }  
   
   visiteClosed(event:any) {
       console.log("VisiteListComponent close",event,this.consultation)
       
       this.loadHeader();
     /*   this.changeDetectorRef.detectChanges()
        this.stateService.updateConsultation(this.consultation);*/
   }

   sortVisites(){
    const sortByTiers = ["nom", "prenom"].includes(this.selectedSortBy);
    const sortParams = {
        sortVisites:{
            type: this.selectedSortBy,
            direction: this.selectedOrder,
            sortByTiers: sortByTiers
        }
    };
    this.setVisiteObjects(sortParams);
   }

   setVisiteObjects(opts = null){
    this.visiteService.getVisitesByConsultation(this.consultation.ID,opts).subscribe(res=>{
      this.consultation.visitesObj = res.result;
      console.log("sortredVisits",res.result);
    })
   }

   selectedVists(event:any) {
		console.log("ConsultationPageComponent selectedVists",event)
		this.selectedVisits=event;
		this.countSelectedVisit=event.length;
		
		if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) 
		       this.changeDetectorRef.detectChanges()
		 
	}

  editCourrier() {
    /*   var lines = [];
   Object.keys(this.selectable).forEach(key => {
     let line:PanierLine=this.selectable[key];
           lines.push(line);
   });*/

 let typeDemandeID:string="SEANCE";
 
 if (this.consultation!=undefined 
   && this.consultation.type!=undefined 
   && this.consultation.type.demande_type!=undefined
   && this.consultation.type.demande_type
   && this.consultation.type.demande_type.ID!=undefined)
   typeDemandeID=this.consultation.type.demande_type.ID;
 console.log("editCourrier",typeDemandeID);
 let lines:any[] = [];
 this.selectedVisits.forEach(elem => {
       if (elem.tiers!=undefined && elem.tiers.dossierID!=undefined) {
         let elt:any={
           dossier: Object.assign({}, elem.tiers),
           visite:Object.assign({}, elem),
         };
         lines.push(elt);
       }
 } );
 
   console.log("editCourrier",this.consultation,this.selectedVisits,lines)
   const dialogRef=this.dialogService.open(ChoiceCourrierComponent, {
           data: {
               typeDemandeID: typeDemandeID,
               /*state: this.currentState,*/
                panierLines: lines,
               consultation: this.consultation
      
              
           },
           width: "30vw",
           draggable: true,
           resizable: true,
           minimizable: true,
           maximizable: true,
       }, (result: any) => {
           if (result) { }
       })

       const sub = dialogRef.componentInstance.onFormClosed.subscribe((result: any) => {
           console.log('Result courriers download',result);
           if(result && result.zipFile && result.zipFile.url){
               //window.open(result.zipFile.url,' _blank');
       
       const dial=this.dialogService.open(LoadDialogComponent, {
                data: {
                    url: result.zipFile.url
                },
          height: "95vh",
          width: "80%",
          minimizable: true,
          maximizable: true,
          draggable: true,
              }, (res: any) => {
                
              })
           }
   })
 }

  editConsultation (event:any) {
    console.log("___cons",this.consultation)
    var type = this.consultation 
    let _opts:any={};
    this.consultationService.getConsultationTypeList().subscribe((res: JSONRpcResponse) => {

      let dataCs={
          action: "modif",
          dataType: "consultation",
          code: undefined,
          /*dossier: this.dossier,*/
          title: "Modification de séance",
          create: true,
          types:res.result,
          consultation: this.consultation,
          updateOnCreate: false,
      }
        
      this.dialogService.open(CreateConsultationDialogComponent, {
                data: dataCs,
                height: "90vh",
                width: "80vw",
                draggable: true,
                maximizable: true,
                minimizable: true,
                resizable: true,
        }, (res: JSONRpcResponse) => {
          if(res){
            console.log("___res",res.result);
            this.consultation = res.result;
            this.setVisiteObjects();
            this.setConsultInfos();
            this.changeDetectorRef.detectChanges();
          }
        }
      )
        
    })
  }

  setConsultInfos(){
		this.title = this.consultation.consultation ? this.consultation.consultation.type.libelle : this.consultation.type.libelle;
    var sub = '<span style="padding-left: 12px;">';
    sub +=(this.consultation.lieu != undefined && this.consultation.lieu.NOM) ? ' À ' + this.consultation.lieu.NOM : ''
		sub += (this.consultation.date_debut && this.consultation.date_fin) 
		?' Du <strong>' + this.formatDateString(this.consultation.date_debut) + '</strong> au <strong>' + this.formatDateString(this.consultation.date_fin) + '</strong>'
		: '';
    sub+= '</span>';
    this.subtitle = sub;
		console.log("___title",this.title,sub)
	}

	formatDateString(isoDateString: string): string {
		const date = new Date(isoDateString);
	  
		const day = String(date.getDate()).padStart(2, '0');
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const year = date.getFullYear();
		const hours = String(date.getHours()).padStart(2, '0');
		const minutes = String(date.getMinutes()).padStart(2, '0');
	  
		return `${day}/${month}/${year} ${hours}:${minutes}`;
	}
	
	
	editRdv() {
			let listeRdv:string="VISITE";
			console.log("editRdv", this.selectedVisits,this.consultation);
			let rdvs:any[] = [];
					    this.selectedVisits.forEach(elem => {
											if (elem.ID!=undefined) {
												
												rdvs.push(elem.ID);
											}
				} );
			if (this.consultation!=undefined 
						&& this.consultation.ID!=undefined 
						&& rdvs.length>0
						) {
			
				
				
				
				let _options:any ={
					"filters": {
						"consultation": {
								"ID": "consultation",
		                        "value": this.consultation.ID
						  },
						  "visites": {
			  					"ID": "visites",
			                         "value": rdvs
						 }
					},
					"format":"PDF"
				}
				console.log("editRdv",_options, rdvs);
				//this.loading=true;
				this.listeService.export(listeRdv, _options)
							.subscribe((list: JSONRpcResponse) => {
						console.log("editRdv lsit",list)	;	
						if (list.result 
							&& list.result.datas!=undefined
							&& list.result.datas.file!=undefined
						) {
							const dial=this.dialogService.open(LoadDialogComponent, {
							  	               data: {
							  	                   url: list.result.datas.file
							  	               },
							  				   height: "95vh",
							  				   width: "80%",
							  				   minimizable: true,
							  				   maximizable: true,
							  				   draggable: true,
							  	           	}, (res: any) => {
							  	               
							  })
						 }
						 
						// this.loading=false; 
						 if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) 
						 		       this.changeDetectorRef.detectChanges()
					})
							
			}	
	   }
 
}
 


